package com.cs.ejobin.data.supabase

import com.cs.ejobin.data.ProfileRepository
import com.cs.ejobin.data.supabase.dto.ProfileRow
import com.cs.ejobin.data.supabase.dto.ProfileUpdateRow
import com.cs.ejobin.model.Skill
import com.cs.ejobin.model.SkillCatalog
import com.cs.ejobin.model.UserProfile
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.auth.auth
import io.github.jan.supabase.postgrest.from

class SupabaseProfileRepository(
    private val supabase: SupabaseClient
) : ProfileRepository {

    override suspend fun getMyProfile(): UserProfile {
        val user = supabase.auth.currentUserOrNull() ?: error("Non authentifié")
        val row = supabase.from("profiles")
            .select { filter { eq("id", user.id) } }
            .decodeSingle<ProfileRow>()

        return row.toDomain(email = user.email ?: "")
    }

    override suspend fun updateMyProfile(
        name: String,
        phone: String,
        isAvailable: Boolean,
        skills: Set<SkillCatalog>,
        photoUrl: String?,
        description: String,
    ): UserProfile {
        val user = supabase.auth.currentUserOrNull() ?: error("Non authentifié")

        val payload = ProfileUpdateRow(
            name = name,
            phone = phone,
            isAvailable = isAvailable,
            skills = skills.map { it.label },
            photoUrl = photoUrl,
            description = description
        )

        supabase.from("profiles")
            .update(payload) { filter { eq("id", user.id) } }

        return getMyProfile()
    }
}

private fun ProfileRow.toDomain(email: String): UserProfile =
    UserProfile(
        id = id,
        email = email,
        name = name,
        phone = phone,
        isAvailable = isAvailable,
        photoUrl = photoUrl,
        skills = skills.mapIndexed { idx, s -> Skill("db$idx", s) },
        description = description
    )